export enum ERECUEST_STATUS {
  DONE = "done",
  PANDING = "pending",
  ERROR = "failed",
  NO_CANDIDATES = "no_candidates",
  HH_TOKENS_EXHAUSTED = "hh_tokens_exhausted",
}
